var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.items)?_c('list-items',{attrs:{"items":_vm.items,"empty-text":_vm.emptyText,"cssClass":_vm.cssClass},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_vm._t("default",function(){return [_vm._v(_vm._s(item))]},{"item":item})]}}],null,true)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }